// extracted by mini-css-extract-plugin
export default {"SocialIcons":"SocialIconsFooter_SocialIcons__pGytD","container":"SocialIconsFooter_container__GFKM3","Icons":"SocialIconsFooter_Icons__BoMgb"};